module.exports = __webpack_public_path__ + "img/canvas-bg8.b11e78e1.png";